"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonComponent = ButtonComponent;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
function ButtonComponent(props) {
    var label = props.label, onPress = props.onPress, ariaLabel = props.ariaLabel, icon = props.icon, _a = props.iconSize, iconSize = _a === void 0 ? 16 : _a, isPending = props.isPending, isDisabled = props.isDisabled, variant = props.variant, color = props.color, backgroundColor = props.backgroundColor, hoverColor = props.hoverColor, _b = props.shape, shape = _b === void 0 ? "rounded" : _b, textSize = props.textSize, textWeight = props.textWeight, textUppercase = props.textUppercase, textCenter = props.textCenter, className = props.className;
    var TEXT_SIZE_CLASSES = {
        xsmall: "text-xs",
        small: "text-sm",
        medium: "text-base",
        large: "text-lg",
        xlarge: "text-xl",
        "2xlarge": "text-2xl",
        "3xlarge": "text-3xl",
        "4xlarge": "text-4xl",
        "5xlarge": "text-5xl",
        "6xlarge": "text-6xl",
        "7xlarge": "text-7xl",
        "8xlarge": "text-8xl",
        "9xlarge": "text-9xl",
    };
    var SHAPE_CLASSES = {
        square: "rounded-none",
        small: "rounded-sm",
        rounded: "rounded-md",
        large: "rounded-lg",
        xlarge: "rounded-xl",
        "2xlarge": "rounded-2xl",
        pill: "rounded-full",
    };
    var classNames = [
        color ? "text-".concat(color) : "",
        backgroundColor ? "bg-".concat(backgroundColor) : "",
        hoverColor ? "hover:bg-".concat(hoverColor) : "",
        SHAPE_CLASSES[shape],
        textSize ? TEXT_SIZE_CLASSES[textSize] : "",
        textWeight ? "font-".concat(textWeight) : "",
        textUppercase ? "uppercase" : "",
        textCenter ? "text-center" : "",
        className !== null && className !== void 0 ? className : "",
    ]
        .filter(Boolean)
        .join(" ");
    return ((0, jsx_runtime_1.jsxs)(react_1.Button, { onPress: onPress, "aria-label": ariaLabel, isPending: isPending, isDisabled: isDisabled, variant: variant, className: classNames, children: [isPending ? (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:refresh-linear", fontSize: iconSize, className: "animate-spin" }) : icon ? (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: icon, fontSize: iconSize }) : null, label] }));
}
